/**
 * @description
 *
 * CartoesTipoRegex é responsável por conter todaa as expressões
 * regulares referentes aos numeros dos cartões das operadoras,
 * retornar todas as bandeiras existentes e obter bandeiras
 * específicas
 */
export class CartoesTipoRegex {
  static Amex = { regExp: /^3[47][0-9]{13}/, nome: 'Amex' };
  static Aura = { regExp: /^507860/, nome: 'Aura' };
  static BaneseCard = { regExp: /^636117/, nome: 'Banese Card' };
  static Cabal = { regExp: /(60420[1-9]|6042[1-9][0-9]|6043[0-9]{2}|604400)/, nome: 'Cabal' };
  static Diners = { regExp: /(36[0-8][0-9]{3}|369[0-8][0-9]{2}|3699[0-8][0-9]|36999[0-9])/, nome: 'Diners' };
  static Discover = { regExp: /^6(?:011|5[0-9]{2})[0-9]{12}/, nome: 'Discover' };
  static Elo = { regExp: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/, nome: 'Elo' };
  // static Elo = { regExp: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])/, nome: 'Elo' };
  static FortBrasil = { regExp: /^628167/, nome: 'Fort Brasil' };
  static GrandCard = { regExp: /^605032/, nome: 'GrandCard' };
  static Hipercard = { regExp: /^606282|^637095|^637599|^637568/, nome: 'Hipercard' };
  static JCB = { regExp: /^(?:2131|1800|35\d{3})\d{11}/, nome: 'JCB' };
  static Mastercard = { regExp: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{14}$/, nome: 'Master' };
  static PersonalCard = { regExp: /^636085/, nome: 'Personal Card' };
  static Sorocred = { regExp: /^627892|^636414/, nome: 'Sorocred' };
  static Valecard = { regExp: /^606444|^606458|^606482/, nome: 'Valecard' };
  static Visa = { regExp: /^4[0-9]{12}(?:[0-9]{3})/, nome: 'Visa' };

  /**
   * @description
   * Obtém uma lista com todas as bandeiras de operadoras
   *
   * @returns
   * Retorna um array com objetos compostos por
   * regExp do tipo RegExp e nome do tipo string
   */
  static obterTodos(): Array<{ regExp: RegExp, nome: string }> {
    return [
      // this.Amex, this.Aura, this.BaneseCard, this.Cabal, this.Diners, this.FortBrasil,this.GrandCard, this.Hipercard, this.JCB,this.PersonalCard, this.Sorocred, this.Valecard,
      this.Discover, this.Elo, this.Mastercard, this.Visa,
    ];
  }

  /**
   * @description
   * Obtém uma bandeira específica
   *
   * @params
   * Recebe um parâmetro do tipo number contendo
   * o número do cartão do usuário
   *
   * @returns
   * Retorna um objeto composto por regExp
   * do tipo RegExp e nome do tipo string
   */
  static obterBandeira(numeroCartao: number): { regExp: RegExp, nome: string } {
    const numerosIniciais = numeroCartao
      .toString()
      .replace(/[^0-9]/g, '');

    const tipoBandeira = this.obterTodos().filter(bandeira => bandeira.regExp.test(numerosIniciais))[0];
    return tipoBandeira;
  }
}
